import { useEffect, useState } from "react";
import type { FavouritesMenuGroup } from "@/types/domain";
import { popupCenter } from "@/utils/popup";
import { fetchFavouritesMenu } from "@/api/menu/api";

export const FavouritesSubMenu = () => {
  const [groups, setGroups] = useState<FavouritesMenuGroup[]>([]);
  const [loaded, setLoaded] = useState(false);

  const load = () => {
    fetchFavouritesMenu(window.location.href)
      .then((groups) => {
        setGroups(groups);
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  };

  useEffect(() => {
    load();
    (window as any).reloadFavouritePanel = load;
    return () => { delete (window as any).reloadFavouritePanel; };
  }, []);

  if (!loaded) {
    return <li className="px-3 py-1 text-xs text-(--layout-side-nav-header)">Loading…</li>;
  }

  return (
    <>
      {groups.map((group) =>
        group.categories.map((cat) => (
          <li key={cat.id} className="px-3 py-1">
            <span
              className="text-xs font-semibold uppercase"
              style={{ color: cat.colour || "var(--layout-side-nav-header)" }}
            >
              {cat.name}
            </span>
            <ul className="mt-0.5 space-y-0.5">
              {cat.favourites.map((fav) => (
                <li key={fav.id}>
                  <button
                    onClick={() => popupCenter(`/handlers/FavouriteEnquiry.aspx?favouriteId=${fav.id}`, "vectaEnquiry", 1024, 768)}
                    className="block w-full text-left py-1.5 text-xs text-(--layout-side-nav-text) hover:bg-white hover:text-black rounded-l-2xl ml-1 truncate cursor-pointer"
                    style={{ paddingLeft: 24 }}
                  >
                    {fav.name}
                  </button>
                </li>
              ))}
            </ul>
          </li>
        ))
      )}
      {groups.length === 0 && (
        <li className="px-3 py-1 text-xs text-(--layout-side-nav-header)">No favourites</li>
      )}
    </>
  );
}
